import { render, staticRenderFns } from "./GatheringAffirm.vue?vue&type=template&id=426101af&scoped=true"
import script from "./GatheringAffirm.vue?vue&type=script&lang=js"
export * from "./GatheringAffirm.vue?vue&type=script&lang=js"
import style0 from "./GatheringAffirm.vue?vue&type=style&index=0&id=426101af&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426101af",
  null
  
)

export default component.exports